import { render } from "./FlaticonsPage.vue?vue&type=template&id=3e5ca11d&ts=true"
import script from "./FlaticonsPage.vue?vue&type=script&lang=ts"
export * from "./FlaticonsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__